import type { BlockViewProps, RelatedItem } from '@plone/types';
import cx from 'classnames';
import { Image } from '@plone/volto/components';
import { H3, Text } from '../../Typography';
import { ReadMoreLink } from '../../ReadMoreLink';
import { ButtonLink } from '../../Button';
import downloadSvg from '../../../assets/download.svg';
import { Tags } from '../../Tag/Tags';

type PublicationTeaserData = {
  title: string;
  head_title?: string;
  hide_description: boolean;
  description: string;
  preview_image: undefined | { image_field: string }[];
  createdAt: string;
  tags: string[];
  href:
    | undefined
    | (RelatedItem & {
        tags: string[];
        hasPreviewImage: boolean;
        created: string;
      })[];
};
export const Publication = ({
  data,
  content,
  isEditMode,
}: BlockViewProps & {
  data: PublicationTeaserData;
  isEditMode: boolean;
  content?: {
    styles: { gridCutoff: number };
  };
}) => {
  const href = data.href?.[0];
  const image = data.preview_image?.[0];
  const horizontal = (content?.styles?.gridCutoff || 0) <= 2;

  return (
    <div
      className={cx(
        'teaser',
        'publication-teaser',
        horizontal && 'publication-teaser--horizontal',
      )}
    >
      {href && (
        <div className="teaser-item default">
          {(href.hasPreviewImage || href.image_field || image) && (
            <div className="image-wrapper">
              <Image
                item={image || href}
                imageField={image ? image.image_field : href.image_field}
                alt=""
                loading="lazy"
                responsive={true}
              />
            </div>
          )}
          <div className="teaser__content">
            {data?.head_title && <Text size="h2">{data.head_title}</Text>}

            <H3 size="h3" className="headline">
              {data?.title}
            </H3>
            {!data.hide_description && (
              <Text size="sm" weight="400">
                {data?.description}
              </Text>
            )}
            <div className="teaser__outline-spacer" />
            <Tags tags={href?.tags} />
            <div className="teaser__links">
              <ReadMoreLink item={href} />
              <ButtonLink
                color="tertiary"
                size="medium"
                href={href['@id'] + '/@@download/attachment'}
                style={{ margin: 0, float: 'right' }}
              >
                <img alt="Download" src={downloadSvg} />
              </ButtonLink>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
